import React from "react";

function NailStylist() {
  return (
    <main>
        <section className="hero">
            <div>
            <h1>NailStylist</h1>
            <p>Find the best NailStylist in your area!</p>
            </div>
        </section>
    </main>
   
  );
}

export default NailStylist;
